module.exports = __webpack_public_path__ + "static/media/touch-red.cae29bff.gif";


//////////////////
// WEBPACK FOOTER
// ./src/icons/touch-red.gif
// module id = ./src/icons/touch-red.gif
// module chunks = 0